<template>
  <div>
    <b-form-group>
      <b-form-radio-group
        v-model="filter.status"
        :options="statusOptions || options.filter.status"
        button-variant="primary"
        buttons
        class="status-btn"
      />
    </b-form-group>
    <div
      class="d-flex flex-row justify-content-between filterContainer"
    >
      <b-input
        v-model="filter.keyword"
        class="flex-grow-1"
        size="sm"
        :placeholder="$t('inputs.keyword.placeholder', 'Keywords')"
      />
      <b-form-select
        v-model="filter.order"
        size="sm"
        :options="options.filter.order"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    filter: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    }
  },

  data() {
    return {
      counts: {
        new: '?',
        seen: '?',
        inprocess: '?',
        accepted: '?',
        rejected: '?',
        invalid: '?'
      }
    }
  },

  computed: {
    statusOptions() {
      let result = [];

      for (let i of this.options.filter.status) {
        result.push({
          text: `${i.text} (${this.counts[i.value]})`,
          value: i.value,
        });
      }

      return result;
    },
  },

  watch: {
  },

  mounted() {
    this.getCandidatesCounts();
  },

  methods: {
    getCandidatesCounts() {
      this.axios.get('/offerApply/candidates_counts?offer=' + this.$route.query.offer)
        .then( response => {
          this.counts = response.data;
        })
        .catch();
    },
  }
}
</script>

<style lang="scss" scoped>
  .filterContainer {
    * {
      margin: 5px;
    }
  }
</style>

<style lang="scss">
  .status-btn {
    display: block;
    label {
      cursor: pointer;
      background: #009090;
      border: #005f5f;

      @media screen and (max-width: 479px) {
        width: 100% !important;
      }

      &.active {
        background: #005f5f !important;
      }

      &:hover {
        background: #005f5f;
      }
    }
  }
</style>
